/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React from 'react';
import styled from 'styled-components';
import Money from '../../assets/icons/Money.svg';
import Bank from '../../assets/icons/Bank.svg';
import Laptop from '../../assets/icons/Laptop.svg';
import MoneyVector from '../../assets/icons/vectors/Money_Vector.svg';
import BankVector from '../../assets/icons/vectors/Bank_Vector.svg';
import LaptopVector from '../../assets/icons/vectors/Laptop_Vector.svg';
import Button from '../Button';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ROUTES } from '../Routes';
import {
  Heading,
  Text,
  CenteredContainer,
  // VariableText,
  CustomBtn,
} from '../Typography';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #e3f0ff;
  border-radius: 20px;
  width: 80%;
  padding: 0px 50px;
  box-sizing: border-box;
  @media (max-width: 767px) {
    display: none;
  }
`;
const VariableText = styled.p`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight || 400};
  font-size: ${(props) => props.Size || '16px'};
  line-height: ${(props) => props.lineHeight || '150%'};
  text-align: center;
  color: ${(props) => props.color || '#000000'};
  white-space: pre-wrap;
  // width: 50%;
  margin-top: ${(props) => props.marginTop || '0px'};
`;
const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // width: 50%;
`;
const LineControl = styled.div`
  display: flex;
  margin-top: 80px;
  width: 50%;
`;
const Line = styled.hr`
  width: 100%;
  height: 0px;
  border: 0.75px dashed #497cb6;
`;
const StyledVectorContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const StyledVector = styled.img`
  position: absolute;
`;
const StyledImage = styled.img`
  position: relative;
  z-index: 1;
`;
const ImportantTextContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 25px 0px 25px;
  background: rgba(252, 170, 232, 0.2);
`;
const ContributeProcess = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    const isContributionEnabled =
      process.env.REACT_APP_CONTRIBUTION_ENABLED === 'true';

    if (isContributionEnabled) {
      navigate(ROUTES.CONTRIBUTION_FIRST_PAGE);
    } else {
      toast.error('Contribution is not Enabled', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
    }
  };
  return (
    <MainContainer>
      <Heading margin="30px">Online Contribution Process</Heading>
      <Text margin="40px">
        To make contribution through a direct transfer from your bank, through a
        secure Payment Gateway
      </Text>
      <CenteredContainer>
        <ImageContainer>
          <StyledVectorContainer>
            <StyledVector src={MoneyVector} />
            <StyledImage src={Money} alt="Money" />
          </StyledVectorContainer>
          <VariableText marginTop="50px">
            Please <strong>enter the amount</strong> you wish to contribute
          </VariableText>
        </ImageContainer>
        <LineControl>
          <RadioButtonCheckedIcon
            fontSize="small"
            style={{ color: '#497CB6' }}
          />
          <Line />
          <ArrowForwardIosIcon
            fontSize="small"
            style={{ color: '#497CB6', marginLeft: '-12px' }}
          />
        </LineControl>
        <ImageContainer>
          <StyledVectorContainer>
            <StyledVector src={BankVector} />
            <StyledImage src={Bank} alt="Bank" />
          </StyledVectorContainer>
          <VariableText marginTop="50px">
            <strong>Select the Bank</strong> from which you wish to pay. You
            will be re-directed to your Bank’s netbanking login page
          </VariableText>
        </ImageContainer>
        <LineControl>
          <RadioButtonCheckedIcon
            fontSize="small"
            style={{ color: '#497CB6' }}
          />
          <Line />
          <ArrowForwardIosIcon
            fontSize="small"
            style={{ color: '#497CB6', marginLeft: '-12px' }}
          />
        </LineControl>
        <ImageContainer>
          <StyledVectorContainer>
            <StyledVector src={LaptopVector} />
            <StyledImage src={Laptop} alt="Laptop" />
          </StyledVectorContainer>
          <VariableText marginTop="50px">
            After confirming the payment you will be directed back to{' '}
            <strong>BSG’s Contribution site</strong>
          </VariableText>
        </ImageContainer>
      </CenteredContainer>
      <CenteredContainer></CenteredContainer>
      <CenteredContainer>
        <VariableText lineHeight="175%">
          Your contribution receipt will be mailed to you immediately on
          completion of transaction. In case of any query, please write to us at{' '}
          <a href="/">contribution@bharatsokagakakai.org</a>
        </VariableText>
      </CenteredContainer>
      {/* <ImportantTextContainer>
        <VariableText color="#f4422a" lineHeight="175%" fontWeight="600">
          Important-Please check your Name and Address displayed above, to
          ensure that they are correct. As the Contribution Receipt will be
          generated on the same. In case they are not correct. Please DO NOT
          proceed, and contact your District Stats Coordinator or District
          Leader for getting the corrections made. Please make the contributions
          only after the corrections have been done.
        </VariableText>
      </ImportantTextContainer> */}
      <CustomBtn marginTop="50px" marginBottom="50px" onClick={handleClick}>
        <Button>Click here to Contribute</Button>
      </CustomBtn>
    </MainContainer>
  );
};
export default ContributeProcess;
